import React from 'react';

import { Flex } from '@chakra-ui/react';

export default function ModalSection({ children, ...rest }) {
  return (
    <Flex
      p={6}
      flexDir="column"
      borderBottom="1px"
      borderColor="gray.100"
      {...rest}>
      {children}
    </Flex>
  );
}
